import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { FocusModule } from '../focus/focus.module';
import { MobileModalWindowComponent } from '../mobile-modal-window/mobile-modal-window.component';
import { MobileModalWindowModule } from '../mobile-modal-window/mobile-modal-window.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';

import { FlyoutBodyComponent } from './flyout.body.component';
import { FlyoutDirective } from './flyout.directive';

@NgModule({
  declarations: [FlyoutDirective, FlyoutBodyComponent],
  imports: [CommonModule, NgbPopoverModule, MobileModalWindowModule, ScrollbarModule, FocusModule],
  exports: [FlyoutDirective, NgbPopoverModule, FlyoutBodyComponent, MobileModalWindowComponent]
})
export class FlyoutModule {}

export * from './flyout.body.component';
export * from './flyout.directive';
